"use strict";
/// <reference path="irep.js"/>


IREP.cmsedit = (function () {
    var childsReturnValue = 0;
    var popup;

    var init = function () {
        $(this).parent().click(popupFocus);
        //$('#divEditContainer').style.height = '142px';
    };

    function popupFocus() {
        popup.focus();
    }

    var popupWindow = function (url) {
        if (!popup) {
            popup = window.open(url, '_blank', 'toolbar=no, directories=no, location=no, status=yes, menubar=no, resizable=no, scrollbars=yes, width=900, height=600, modal=yes');
        }
        else {
            popupFocus();
        }
    };

    var popupValue = function (value) {
        $("[ID*=imgSelThumbnail]").value = value;
    };

    function flipEditor() {
        if ($('#tblNewsEditMain').style.display === '') {
            $('#tblNewsEditMain').style.display = 'none';
            $('#lnkFlipEditor').innerHTML = 'Minimize';
            $('#divEditContainer').style.height = '395px';
        }
        else {
            $('#tblNewsEditMain').style.display = '';
            $('#lnkFlipEditor').innerHTML = 'Maximize';
            $('#divEditContainer').style.height = '142px';
        }
    }

    return {
        init: init
    };
})();